import { getElectronAPI, isDesktopApp } from '@/desktop/electronApi';
import { useDesktopSessionStore } from '@/desktop/desktopSessionStore';
import { useAuthStore } from '@/store/authStore';

/**
 * Wipe device-local desktop bind so first login → wizard can run again.
 * Clears Electron config/vault + renderer localStorage keys.
 */
export async function startFreshOnThisPc(): Promise<void> {
  if (!isDesktopApp()) return;
  const api = getElectronAPI();
  try {
    if (api?.vault.factoryReset) {
      await api.vault.factoryReset();
    } else if (api) {
      await api.vault.wipeAll();
      await api.setConfig({
        boundCompanyCode: null,
        setupComplete: false,
        desktopSyncMode: null,
      });
    }
  } catch {
    /* still clear renderer state */
  }

  useDesktopSessionStore.getState().clearLocalUnlock();
  useDesktopSessionStore.getState().setSetupState({
    setupComplete: false,
    boundCompanyCode: null,
    desktopSyncMode: null,
    pendingDesktopSetup: true,
  });
  useDesktopSessionStore.getState().setPendingEnrollAfterLogin(false);
  useDesktopSessionStore.getState().setResetPinAfterLogin(false);
  useAuthStore.getState().clearAuth();

  try {
    localStorage.removeItem('company_code');
    localStorage.removeItem('auth-storage');
    localStorage.removeItem('desktop-session');
  } catch {
    /* ignore */
  }
}
